// language=GraphQL
export const ALL_CUSTOMER_ESIMS_QUERY = `query Query {
  customerEsims: customerEsims {
    id
    referenceNo
    serviceName
    label
    purchaseId
    iccid
    startDate
    endDate
  }
}`

// language=GraphQL
export const SINGLE_CUSTOMER_ESIM_QUERY = `query Query($id: ID!) {
  customerEsim: customerEsim(id: $id) {
    id
    referenceNo
    serviceName
    label
    purchaseId
    iccid
    startDate
    endDate
  }
}`

// language=GraphQL
export const CREATE_CUSTOMER_ESIM_MUTATION = `
  mutation Mutation($input: CreateCustomerEsimInput) {
    customerEsim: createCustomerEsim(input: $input) {
      id
      referenceNo
      serviceName
      label
      purchaseId
      iccid
      startDate
      endDate
    }
  }`

// language=GraphQL
export const UPDATE_CUSTOMER_ESIM_MUTATION = `
  mutation Mutation($input: UpdateCustomerEsimInput) {
    customerEsim: updateCustomerEsim(input: $input) {
      id
      referenceNo
      serviceName
      label
      purchaseId
      iccid
      startDate
      endDate
    }
  }`

// language=GraphQL
export const DELETE_CUSTOMER_ESIM_MUTATION = `
  mutation Mutation($input: DeleteCustomerEsimInput) {
    deleteCustomerEsim(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_CUSTOMER_ESIM_MUTATION = `
  mutation Mutation($input: DeleteCustomerEsimInput) {
    forceDeleteCustomerEsim(input: $input) {
      success
    }
  }`
